// ══════════════════════════════════════════════════════════════════════════════════════════════
//  SoloConFuncion y RutaDeFuncion · LO DE UNA FUNCIÓN EN DESARROLLO, SOLO CON ELLA ENCENDIDA (t279, 17-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  <SoloConFuncion clave="coste-sillon">…</SoloConFuncion>      un botón, una tarjeta, un trozo de pantalla: apagada, nada
//  <Route path="/coste-sillon" element={<RutaDeFuncion clave="coste-sillon"><CosteSillon /></RutaDeFuncion>} />
//      la pantalla entera: apagada, como si la dirección no existiera (lleva al inicio). Mientras el servidor no ha dicho qué
//      está encendido no pinta nada y no expulsa a nadie (así un F5 dentro de la pantalla no te saca de ella).
//  Las direcciones de cada función se declaran en shared/funciones.json (`pantallas`): la guardia exige que App.jsx las monte
//  dentro de su RutaDeFuncion. El hook, para lo demás: hooks/useFuncion.
import { Navigate } from 'react-router-dom'
import { useFuncion, useEstadoFuncion } from '../hooks/useFuncion.js'

export function SoloConFuncion({ clave, children, sino = null }) {
  return useFuncion(clave) ? children : sino
}

export function RutaDeFuncion({ clave, children }) {
  const { encendida, sabida } = useEstadoFuncion(clave)
  if (encendida) return children
  if (!sabida) return null
  return <Navigate to="/" replace />
}

export default SoloConFuncion
